import { getTvObject } from '@costar-ui/cosmos';
import spacingOptions from '../../../common/space-options/spacing-options.esm.js';

var padding = getTvObject({
  none: spacingOptions.padding.none,
  xxs: spacingOptions.padding.xxs,
  xs: ['px-3', 'py-1.5'],
  sm: ['px-4', 'py-2'],
  md: ['px-5', 'py-2.5'],
  lg: ['px-6', 'py-3'],
  xl: ['px-7', 'py-3.5'],
  '2xl': ['px-8', 'py-4'],
  '3xl': spacingOptions.padding['3xl']
});

export { padding as default };
//# sourceMappingURL=padding.styles.esm.js.map
